import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateNotificationStatusParams } from "core/http/service/notification/types";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
};

const updateNotificationStatus = createSlice({
  name: "updateNotificationStatus",
  initialState,
  reducers: {
    updateNotificationStatusStart: (
      state,
      action: PayloadAction<UpdateNotificationStatusParams>
    ) => {
      state.status = ReduxStateType.INIT;
    },
    updateNotificationStatusSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    updateNotificationStatusFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  updateNotificationStatusStart,
  updateNotificationStatusSuccess,
  updateNotificationStatusFailed,
} = updateNotificationStatus.actions;

export default updateNotificationStatus.reducer;
